import React, { useState } from 'react';
import { Table, Card, Tag, Button, Space, Badge, Row, Col, Statistic, Select, Switch, message } from 'antd';
import { AlertOutlined, CheckCircleOutlined, BellOutlined } from '@ant-design/icons';

const alertData = [
  { key: '1', type: 'traffic', level: 'warning', iccid: '898603...3421', client: '深圳割草机科技', msg: '流量使用已达80%阈值', time: '2026-03-13 14:23:11', status: 'unread' },
  { key: '2', type: 'offline', level: 'error', iccid: '898603...3422', client: '广州CPE公司', msg: '设备离线超过30分钟', time: '2026-03-13 13:45:22', status: 'unread' },
  { key: '3', type: 'fence', level: 'error', iccid: '898603...3423', client: '北京VR体验馆', msg: '设备越界电子围栏', time: '2026-03-13 12:30:08', status: 'unread' },
  { key: '4', type: 'traffic', level: 'error', iccid: '898603...3424', client: '上海安防', msg: '流量100%已停机', time: '2026-03-13 11:15:44', status: 'read' },
  { key: '5', type: 'behavior', level: 'warning', iccid: '898603...3425', client: '成都对讲机', msg: '异常高频开关机', time: '2026-03-13 10:08:33', status: 'read' },
  { key: '6', type: 'offline', level: 'warning', iccid: '898603...3426', client: '武汉IoT', msg: '卡片离线15分钟', time: '2026-03-13 09:55:10', status: 'read' },
];

const levelMap: Record<string, any> = {
  error: { color: 'error', text: '严重' },
  warning: { color: 'warning', text: '警告' },
  info: { color: 'processing', text: '提示' },
};

const typeMap: Record<string, string> = {
  traffic: '流量异常', offline: '设备离线', fence: '越界告警', behavior: '异常行为'
};

const AlertManage: React.FC = () => {
  const [data, setData] = useState(alertData);

  const handleRead = (key: string) => {
    setData(prev => prev.map(d => d.key === key ? { ...d, status: 'read' } : d));
    message.success('已标记为已读');
  };

  return (
    <div style={{ padding: 16 }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {[
          { title: '总告警', value: 23, color: '#ff4d4f', icon: <AlertOutlined /> },
          { title: '严重', value: 8, color: '#ff4d4f' },
          { title: '警告', value: 12, color: '#faad14' },
          { title: '已处理', value: 15, color: '#52c41a', icon: <CheckCircleOutlined /> },
        ].map((item, i) => (
          <Col span={6} key={i}>
            <Card bordered={false} style={{ borderRadius: 8 }}>
              <Statistic title={item.title} value={item.value} valueStyle={{ color: item.color, fontWeight: 700 }} />
            </Card>
          </Col>
        ))}
      </Row>

      {/* 通知配置 */}
      <Card title={<span><BellOutlined /> 预警通知配置</span>} bordered={false} style={{ borderRadius: 8, marginBottom: 16 }}>
        <Row gutter={[24, 12]}>
          {[
            { label: '流量阈值预警（80%）', key: 'traffic80' },
            { label: '流量耗尽预警（100%）', key: 'traffic100' },
            { label: '设备离线预警', key: 'offline' },
            { label: '越界告警', key: 'fence' },
            { label: '异常行为预警', key: 'behavior' },
            { label: '短信通知', key: 'sms' },
            { label: '邮件通知', key: 'email' },
          ].map(item => (
            <Col span={8} key={item.key}>
              <Space>
                <Switch defaultChecked={item.key !== 'email'} size="small" />
                <span style={{ fontSize: 13 }}>{item.label}</span>
              </Space>
            </Col>
          ))}
        </Row>
      </Card>

      <Card
        title="告警记录"
        extra={
          <Space>
            <Select defaultValue="" style={{ width: 120 }} options={[
              { value: '', label: '全部类型' },
              { value: 'traffic', label: '流量异常' },
              { value: 'offline', label: '设备离线' },
              { value: 'fence', label: '越界告警' },
            ]} />
            <Button onClick={() => message.success('已全部标记为已读')}>全部已读</Button>
          </Space>
        }
        bordered={false}
        style={{ borderRadius: 8 }}
      >
        <Table
          dataSource={data}
          size="small"
          pagination={{ pageSize: 10 }}
          columns={[
            {
              title: '级别', dataIndex: 'level', key: 'level', width: 80,
              render: (v: string) => <Tag color={levelMap[v]?.color}>{levelMap[v]?.text}</Tag>
            },
            { title: '类型', dataIndex: 'type', key: 'type', width: 100, render: v => typeMap[v] },
            { title: 'ICCID', dataIndex: 'iccid', key: 'iccid', width: 130 },
            { title: '归属客户', dataIndex: 'client', key: 'client', width: 140 },
            { title: '告警内容', dataIndex: 'msg', key: 'msg' },
            { title: '时间', dataIndex: 'time', key: 'time', width: 170 },
            {
              title: '状态', dataIndex: 'status', key: 'status', width: 90,
              render: v => <Badge status={v === 'unread' ? 'error' : 'default'} text={v === 'unread' ? '未读' : '已读'} />
            },
            {
              title: '操作', key: 'action', width: 120,
              render: (_: any, r: any) => (
                <Space>
                  {r.status === 'unread' && <Button size="small" onClick={() => handleRead(r.key)}>标记已读</Button>}
                  <Button size="small" type="link">处理</Button>
                </Space>
              )
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default AlertManage;
